import { Component, OnDestroy, OnInit } from '@angular/core';
import { VerificationDtzFormDto } from '../shared/dto/verification-dtz-form.dto';
import { CertificateService, RecaptchaVerificationDto } from '../shared/services/certificate.service';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService, StorageType } from 'gast-common-ng';
import { DateStringUtil } from '../shared/utils/date-string-util';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamLevelWithDescriptionEnum } from '../shared/enum/exam-level-with-description.enum';
import { ExamLevelEnum } from '../shared/enum/exam-level.enum';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from '../shared/utils/date-util';

// import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-verification-dtz-form',
  templateUrl: './verification-dtz-form.component.html',
  styleUrls: ['./verification-dtz-form.component.css']
})
export class VerificationDtzFormComponent implements OnInit, OnDestroy {
  // tslint:disable:no-inferrable-types
  private subscription: Subscription = new Subscription();

  dtzCertificateTemplatePath: string = './assets/img/dtz_certificate_template.png';

  bsConfig: BsDatepickerConfig;
  minimalAgeRequirement: Date;

  verificationResult: boolean = undefined;

  recaptchaVerificationDto: RecaptchaVerificationDto;

  isSubmitted: boolean = false;
  hasError: boolean = false;
  isLoading: boolean = false;

  // default max scores
  maxListeningAndReadingScore: string = '45';
  maxReading: string = '25';
  maxListening: string = '20';
  maxWritingScore: string = '20';
  maxSpeakingScore: string = '100';

  // inputs
  participantNumber: string;
  fullName: string;
  dateOfBirth: Date;
  examDate: Date;
  listeningAndReadingScore: string;
  listeningAndReadingLevel: string;
  writingScore: string;
  writingLevel: string;
  speakingScore: string;
  speakingLevel: string;
  overallResult: string;

  isNtaListening = false;
  isNtaReading = false;
  isNtaWriting = false;
  isNtaSpeaking = false;

  levelsWithDescription: Array<string>;
  levels: Array<string>;
  isFromQrcode: boolean = false;

  isFromPdf: boolean = false;

  constructor(
    private certificationService: CertificateService,
    private spinnerService: NgxSpinnerService,
    private storageService: StorageService,
    private router: Router,
    private localeService: BsLocaleService,
    private activatedRoute: ActivatedRoute,
    private toaster: ToastrService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.activatedRoute.queryParamMap.subscribe(param => {

      this.isFromQrcode = param.get('from-qr-code') === 'true';

      this.isFromPdf = param.get('from-pdf') === 'true';

      if (this.isFromQrcode) {

        const dtoFromQrCode: VerificationDtzFormDto = this.storageService.getItem('VERIFICATION_FORM_QR_CODE', StorageType.Local);

        if (dtoFromQrCode) {

          this.fillForm(dtoFromQrCode);

        } else {

          this.toaster.error('Kamera nicht gefunden');

          this.router.navigate(['verification-dtz-choice']).then(() => window.scrollTo({ top: 0 }));
        }

      } else if (this.isFromPdf) {

        const dtoFromPdf: VerificationDtzFormDto = this.storageService.getItem('VERIFICATION_FORM_PDF', StorageType.Local);

        if (dtoFromPdf) {

          this.fillForm(dtoFromPdf);

        } else {

          this.toaster.error('Data nicht gefunden!');

          this.router.navigate(['verification-dtz-choice']).then(() => window.scrollTo({ top: 0 }));
        }
      }
    });

    this.bsConfig = VerificationDtzFormComponent.getBsConfig();
    this.minimalAgeRequirement = VerificationDtzFormComponent.getMinimalAgeRequirement();

    // init datepicker locale
    this.localeService.use('de');
    this.levelsWithDescription = Object.values(ExamLevelWithDescriptionEnum);
    this.levels = Object.values(ExamLevelEnum);

    this.subscription.add(this.certificationService.dtzResultLoaded.subscribe((result: boolean) => {
      this.verificationResult = result;
      this.isLoading = false;
      this.spinnerService.hide();
    }));

    this.subscription.add(this.certificationService.verificationError.subscribe(() => {
      this.verificationResult = false;
      this.isLoading = false;
      this.spinnerService.hide();
    }));

    // this.subscription.add(
    //   this.certificationService.recaptchaVerificationLoaded.subscribe((response: RecaptchaVerificationDto) => {

    //     if (response) {

    //       this.recaptchaVerificationDto = response;

    //       this.checkCertificate();

    //     } else {

    //       this.verificationResult = false;

    //       this.isLoading = false;

    //       this.spinnerService.hide();
    //     }
    //   }));
  }

  ngOnDestroy(): void {

    this.subscription.unsubscribe();
  }

  submit(): void {

    this.isSubmitted = true;

    this.logDTZ();

    if (this.checkIfAllFieldsAreFilled()) {

      this.spinnerService.show();

      // this.recaptchaV3Service.execute('certificateCheck').subscribe(
      //   (captchaGoogleToken) => this.verifyCaptcha(captchaGoogleToken));
      this.checkCertificate();

    } else {

      this.hasError = true;

      this.spinnerService.hide();
    }
  }

  checkIfAllFieldsNotFilled(): boolean {
    if (!this.participantNumber || !this.fullName || !this.dateOfBirth || !this.examDate
      || !this.isNotNullOrZero(this.listeningAndReadingScore) || !this.listeningAndReadingLevel
      || (!this.isNtaWriting && (!this.isNotNullOrZero(this.writingScore) || !this.writingLevel))
      || (!this.isNtaSpeaking && (!this.isNotNullOrZero(this.speakingScore) || !this.speakingLevel))
      || !this.overallResult) {
      return true;
    }
    return false;
  }

  backToDtzChoice(): void {
    this.removeQrCodeAndPdfDataFromStorage();
    this.router.navigate(['verification-dtz-choice']).then(() => window.scrollTo({ top: 0 }));
  }

  checkInputLength(): void {

    if (this.participantNumber && this.participantNumber.toString().length < 4) {

      this.participantNumber = '0';
    }
  }

  clearAllFields() {

    this.isSubmitted = false;
    this.hasError = false;
    this.isLoading = false;

    this.participantNumber = undefined;
    this.fullName = undefined;
    this.dateOfBirth = undefined;
    this.examDate = undefined;
    this.listeningAndReadingScore = undefined;
    this.listeningAndReadingLevel = undefined;
    this.writingScore = undefined;
    this.writingLevel = undefined;
    this.speakingScore = undefined;
    this.speakingLevel = undefined;
    this.overallResult = undefined;

    this.isNtaListening = undefined;
    this.isNtaReading = undefined;
    this.isNtaWriting = undefined;
    this.isNtaSpeaking = undefined;
  }

  exemptFromListeningOrListening(): void {
    if (this.isNtaListening) {
      this.maxListeningAndReadingScore = this.maxReading;
    }
    if (this.isNtaReading) {
      this.maxListeningAndReadingScore = this.maxListening;
    }
    if (!this.isNtaListening && !this.isNtaReading) {
      this.maxListeningAndReadingScore = '45';
    }
  }

  /**
   * if value not exist and value is not zero then false
   * NOTE: !value can be zero
   */
  public isNotNullOrZero(value: string): boolean {

    return (value || value !== '0') && value !== undefined;
  }

  private logDTZ(): void {
    console.log('participant number: ' + this.participantNumber);
    console.log('full name: ' + this.fullName);
    console.log('date of birth: ' + DateStringUtil.getDateString(this.dateOfBirth));
    console.log('exam date: ' + DateStringUtil.getDateString(this.examDate));
    console.log('listening and reading score: ' + this.listeningAndReadingScore);
    console.log('listening and reading level: ' + this.listeningAndReadingLevel);
    console.log('writing score: ' + this.writingScore);
    console.log('writing level: ' + this.writingLevel);
    console.log('speaking score: ' + this.speakingScore);
    console.log('speaking level: ' + this.speakingLevel);
    console.log('overall result: ' + this.overallResult);
  }

  /** set config for date picker */
  // tslint:disable-next-line:member-ordering
  private static getBsConfig() {

    return {
      containerClass: 'theme-blue',
      dateInputFormat: 'DD.MM.YYYY'

    } as BsDatepickerConfig;
  }

  // tslint:disable-next-line:member-ordering
  private static getMinimalAgeRequirement(): Date {

    const now: Date = new Date();

    const currentYear: number = now.getFullYear();

    const sixteenYearsAgo: number = currentYear - 16;

    now.setFullYear(sixteenYearsAgo);

    return now;
  }

  private checkIfAllFieldsAreFilled(): boolean {
    let result: boolean = false;
    if (this.participantNumber && this.fullName && this.dateOfBirth && this.examDate
      && this.isNotNullOrZero(this.listeningAndReadingScore) && this.listeningAndReadingLevel
      && (this.isNtaWriting || (this.isNotNullOrZero(this.writingScore) && this.writingLevel))
      && (this.isNtaSpeaking || (this.isNotNullOrZero(this.speakingScore) && this.speakingLevel))
      && this.overallResult) {
      result = true;
    }
    return result;
  }

  private getVerificationDtzFormDto(): VerificationDtzFormDto {

    const dto = new VerificationDtzFormDto();

    dto.participantNumber = this.participantNumber;
    dto.fullName = this.fullName;
    dto.dateOfBirth = DateStringUtil.getDateString(this.dateOfBirth);
    dto.examDate = DateStringUtil.getDateString(this.examDate);
    dto.maxListeningAndReadingScore = this.maxListeningAndReadingScore;
    dto.maxWritingScore = this.maxWritingScore;
    dto.maxSpeakingScore = this.maxSpeakingScore;
    dto.listeningAndReadingScore = this.listeningAndReadingScore;
    dto.listeningAndReadingLevel = this.listeningAndReadingLevel;
    dto.writingScore = this.writingScore;
    dto.writingLevel = this.writingLevel;
    dto.speakingScore = this.speakingScore;
    dto.speakingLevel = this.speakingLevel;
    dto.overallResult = this.overallResult;

    dto.isNtaListening = this.isNtaListening;
    dto.isNtaReading = this.isNtaReading;
    dto.isNtaWriting = this.isNtaWriting;
    dto.isNtaSpeaking = this.isNtaSpeaking
    return dto;
  }

  private verifyCaptcha(captchaGoogleToken: string): void {

    // this.certificationService.dtzCertificateVerifyUser(captchaGoogleToken);
  }

  private checkCertificate() {
    const verificationDtzFormDto: VerificationDtzFormDto = this.getVerificationDtzFormDto();
    this.certificationService.getDtzFormResults(verificationDtzFormDto);
    this.storageService.setItem('VERIFICATION_FORM', verificationDtzFormDto, StorageType.Local);
    this.removeQrCodeAndPdfDataFromStorage();

    // if (this.recaptchaVerificationDto.captchaVerificationResult) {

    //   const verificationDtzFormDto: VerificationDtzFormDto = this.getVerificationDtzFormDto();

    //   this.certificationService.getDtzFormResults(verificationDtzFormDto);

    //   this.storageService.setItem('VERIFICATION_FORM', verificationDtzFormDto, StorageType.Local);

    //   this.isLoading = true;
    //   this.hasError = false;

    // } else {

    //   this.isLoading = false;

    //   this.verificationResult = false;

    //   this.spinnerService.hide();
    // }
  }

  private fillForm(dto: VerificationDtzFormDto): void {
    this.participantNumber = dto.participantNumber.replace('G', '');
    this.fullName = dto.fullName;
    this.dateOfBirth = DateUtil.formatFrontendDateToDate(dto.dateOfBirth);
    this.examDate = DateUtil.formatFrontendDateToDate(dto.examDate);
    this.maxListeningAndReadingScore = dto.maxListeningAndReadingScore;
    this.maxWritingScore = dto.maxWritingScore;
    this.maxSpeakingScore = dto.maxSpeakingScore;
    this.listeningAndReadingScore = dto.listeningAndReadingScore;
    this.listeningAndReadingLevel = dto.listeningAndReadingLevel;
    this.writingScore = dto.writingScore;
    this.writingLevel = dto.writingLevel;
    this.speakingScore = dto.speakingScore;
    this.speakingLevel = dto.speakingLevel;
    this.overallResult = dto.overallResult;

    // handle NTA from QR or PDF
    if (dto.maxWritingScore.includes('Vom Prüfungsteil befreit')) {
      this.isNtaWriting = true;
    }
    if (dto.maxSpeakingScore.includes('Vom Prüfungsteil befreit')) {
      this.isNtaSpeaking = true;
    }

    if (dto.maxListeningAndReadingScore.includes('25')) {
      this.isNtaListening = true;
    }
    if (dto.maxListeningAndReadingScore.includes('20')) {
      this.isNtaReading = true;
    }
  }

  private removeQrCodeAndPdfDataFromStorage() {
    this.storageService.removeItem('VERIFICATION_FORM_QR_CODE');
    this.storageService.removeItem('VERIFICATION_FORM_PDF');
  }
}
